// extracted by mini-css-extract-plugin
export default {"container":"style_container__F9VfN","title":"style_title__O9Fpj","subTitle":"style_subTitle__2K4dX","btn":"style_btn__KlAnj"};